import { motion } from "motion/react";
import Header from "../../../components/feature/Header";
import Footer from "../../../components/feature/Footer";
import WhatsAppFloating from "../../../components/feature/WhatsAppFloating";
import CookieBanner from "../../../components/feature/CookieBanner";
import QuoteFormSection from "../../home/components/QuoteFormSection";
import SEO from "@/components/feature/SEO";

const ventajas = [
  {
    icon: "ri-money-euro-circle-line",
    title: "Precio competitivo",
    desc: "La opción más económica del mercado. Ideal si buscas calidad sin gastar de más.",
  },
  {
    icon: "ri-temp-hot-line",
    title: "Aislamiento térmico excelente",
    desc: "El PVC aísla mejor que el aluminio. Mantiene tu casa fresca en verano y cálida en invierno.",
  },
  {
    icon: "ri-windy-line",
    title: "Ligereza",
    desc: "Más liviano que el aluminio. Perfecto para huecos amplios donde el peso importa.",
  },
  {
    icon: "ri-ship-line",
    title: "Resistente al salitre",
    desc: "El PVC no se oxida con la humedad del mar. Ideal para zonas costeras de la Costa del Sol.",
  },
];

const tipos = [
  {
    title: "Mini-rolling",
    desc: "Persiana compacta para espacios reducidos. Ideal para ventanas de baño y cocina.",
    icon: "ri-home-smile-line",
  },
  {
    title: "Standard",
    desc: "El modelo más popular para viviendas. Equilibrio entre precio, aislamiento y durabilidad.",
    icon: "ri-building-line",
  },
  {
    title: "Reforzada",
    desc: "Máxima seguridad con lamas más gruesas. Ideal para bajos y locales comerciales.",
    icon: "ri-shield-star-line",
  },
];

const colores = [
  { name: "Blanco", class: "bg-white border-2 border-slate-200" },
  { name: "Madera imitación", class: "bg-amber-700" },
  { name: "RAL custom", class: "bg-gradient-to-br from-slate-400 to-slate-600" },
];

const comparativa = [
  { caracteristica: "Precio", pvc: "✓✓✓ más barato", aluminio: "✓✓ medio" },
  { caracteristica: "Durabilidad", pvc: "✓✓ 15-20 años", aluminio: "✓✓✓ 25-30 años" },
  { caracteristica: "Aislamiento térmico", pvc: "✓✓✓ excelente", aluminio: "✓✓ bueno" },
  { caracteristica: "Salitre marino", pvc: "✓✓✓ excelente", aluminio: "✓ aluminio se oxida" },
  { caracteristica: "Seguridad", pvc: "✓ medio", aluminio: "✓✓✓ excelente" },
];

const faqs = [
  {
    q: "¿Cuánto cuesta una persiana de PVC en Málaga?",
    a: "Una persiana de PVC nueva instalada cuesta entre 140 y 280 € según tamaño y tipo. Es la opción más económica del mercado con muy buen aislamiento térmico.",
  },
  {
    q: "¿El PVC aguanta el sol de Málaga?",
    a: "Sí, el PVC que usamos está tratado contra los rayos UV. No se decolora ni se deforma con el calor mediterráneo. Garantía de 2 años.",
  },
  {
    q: "¿Es mejor PVC o aluminio para la playa?",
    a: "Para zonas muy costeras el PVC es mejor porque no se oxida con la sal del mar. El aluminio puede oxidarse si no se mantiene bien en ambientes salinos.",
  },
  {
    q: "¿Se puede motorizar una persiana de PVC?",
    a: "Sí, se motoriza igual que una de aluminio. Al ser más ligera, incluso necesita un motor de menos potencia, lo que reduce el coste.",
  },
  {
    q: "¿Cuánto dura una persiana de PVC?",
    a: "Con un mantenimiento básico, una persiana de PVC dura entre 15 y 20 años. Es una inversión muy rentable para el precio que tiene.",
  },
];

export default function PersianasPVC() {
  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="Persianas de PVC Málaga | Económicas y Aislantes"
        description="Persianas de PVC en Málaga: económicas, ligeras y aislantes. Ideal clima mediterráneo. Instalación profesional. ☎ 951 12 07 70"
        canonical="/persianas/persianas-pvc/"
        breadcrumbs={[{ name: "Inicio", path: "/" }, { name: "Persianas", path: "/persianas" }, { name: "Persianas de PVC" }]}
      />
      <Header />
      <main>
        {/* HERO */}
        <section className="bg-white pt-24 md:pt-[72px]">
          <div className="max-w-container mx-auto px-4 md:px-6 py-12 md:py-24">
            <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
              <div className="w-full lg:w-[60%] flex flex-col gap-6">
                <div className="inline-flex items-center gap-2 bg-accent text-text-primary font-body font-semibold text-sm px-4 py-2 rounded-pill w-fit">
                  <span>⚡</span> 24h · Respuesta en 20 min
                </div>
                <h1 className="font-heading font-extrabold text-4xl md:text-5xl lg:text-[56px] leading-[1.1] text-text-primary">
                  Persianas de PVC en Málaga
                </h1>
                <p className="font-body text-lg md:text-xl text-text-secondary leading-relaxed max-w-xl">
                  Económicas, ligeras y aislantes. Ideal para el clima mediterráneo de Málaga.
                </p>
                <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
                  <a
                    href="tel:+34951120770"
                    className="inline-flex items-center gap-2 bg-primary hover:bg-primary-dark text-white font-body font-bold text-lg md:text-xl px-8 py-4 rounded-pill transition-colors whitespace-nowrap"
                  >
                    <span>📞</span> 951 12 07 70
                  </a>
                  <a
                    href="#presupuesto"
                    className="inline-flex items-center gap-2 border-2 border-secondary text-secondary hover:bg-secondary hover:text-white font-body font-semibold text-base px-6 py-3.5 rounded-pill transition-colors whitespace-nowrap"
                  >
                    Pedir presupuesto
                  </a>
                </div>
                <div className="flex flex-wrap items-center gap-4 md:gap-6 mt-2">
                  <span className="flex items-center gap-1.5 font-body font-medium text-sm text-text-secondary"><span className="text-green-600">✓</span> +10 años · desde 2015</span>
                  <span className="flex items-center gap-1.5 font-body font-medium text-sm text-text-secondary"><span className="text-green-600">✓</span> Seguro RC</span>
                  <span className="flex items-center gap-1.5 font-body font-medium text-sm text-text-secondary"><span className="text-green-600">✓</span> Garantía 2 años</span>
                </div>
              </div>
              <div className="w-full lg:w-[40%] relative">
                <div className="relative rounded-3xl overflow-hidden lg:rotate-1 shadow-xl">
                  <div className="absolute inset-0 bg-blue-900/35 z-10 pointer-events-none"></div>
                  <img
                    src="https://images.unsplash.com/photo-1631084650668-5e1f72bf6ce5?w=1200&q=80&auto=format&fit=crop"
                    alt="Persianas de PVC en Málaga - instalación económica"
                    className="w-full h-auto object-cover aspect-[4/3]"
                    loading="eager"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* VENTAJAS */}
        <section className="bg-surface-alt py-16 md:py-24">
          <div className="max-w-container mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <h2 className="font-heading font-bold text-3xl md:text-4xl text-text-primary mb-4">Ventajas del PVC</h2>
              <div className="w-10 h-1 bg-primary mx-auto rounded-full"></div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
              {ventajas.map((v, i) => (
                <motion.div
                  key={v.title}
                  className="bg-white rounded-[20px] p-8 border-t-[6px] border-primary shadow-sm hover:shadow-md transition-shadow"
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-60px" }}
                  transition={{ duration: 0.5, delay: i * 0.1 }}
                >
                  <div className="w-12 h-12 bg-primary/10 text-primary rounded-xl flex items-center justify-center mb-5">
                    <i className={`${v.icon} text-2xl`}></i>
                  </div>
                  <h3 className="font-heading font-bold text-xl text-text-primary mb-2">{v.title}</h3>
                  <p className="font-body text-sm text-text-secondary leading-relaxed">{v.desc}</p>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        {/* TIPOS */}
        <section className="bg-white py-16 md:py-24">
          <div className="max-w-container mx-auto px-4 md:px-6">
            <h2 className="font-heading font-bold text-3xl md:text-4xl text-text-primary text-center mb-12">Tipos</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto">
              {tipos.map((t, i) => (
                <motion.div
                  key={t.title}
                  className="bg-surface-alt rounded-[20px] p-8 hover:shadow-md transition-shadow"
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: i * 0.1 }}
                >
                  <div className="w-12 h-12 bg-secondary/10 text-secondary rounded-xl flex items-center justify-center mb-5">
                    <i className={`${t.icon} text-2xl`}></i>
                  </div>
                  <h3 className="font-heading font-bold text-xl text-text-primary mb-2">{t.title}</h3>
                  <p className="font-body text-sm text-text-secondary leading-relaxed">{t.desc}</p>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        {/* COLORES + COMPARATIVA */}
        <section className="bg-surface-alt py-16 md:py-24">
          <div className="max-w-container mx-auto px-4 md:px-6">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-start">
              {/* Colores */}
              <div>
                <h2 className="font-heading font-bold text-3xl md:text-4xl text-text-primary mb-4">Colores</h2>
                <p className="font-body text-lg text-text-secondary mb-6">
                  Disponibles en los acabados más populares. También fabricamos a medida en cualquier RAL.
                </p>
                <div className="flex flex-wrap gap-4 mb-8">
                  {colores.map((c, i) => (
                    <motion.div
                      key={c.name}
                      className="flex flex-col items-center gap-2"
                      initial={{ opacity: 0, scale: 0.9 }}
                      whileInView={{ opacity: 1, scale: 1 }}
                      viewport={{ once: true }}
                      transition={{ duration: 0.3, delay: i * 0.06 }}
                    >
                      <div className={`w-14 h-14 rounded-full ${c.class} shadow-sm`}></div>
                      <span className="font-body text-sm text-text-secondary">{c.name}</span>
                    </motion.div>
                  ))}
                </div>
              </div>

              {/* Comparativa */}
              <div className="bg-white rounded-3xl p-6 md:p-8 shadow-sm overflow-x-auto">
                <h3 className="font-heading font-bold text-2xl text-text-primary mb-6">Comparación PVC vs Aluminio</h3>
                <table className="w-full">
                  <thead>
                    <tr className="border-b-2 border-border">
                      <th className="text-left font-heading font-bold text-sm text-text-primary pb-3 pr-4">Característica</th>
                      <th className="text-left font-heading font-bold text-sm text-primary pb-3 pr-4">PVC</th>
                      <th className="text-left font-heading font-bold text-sm text-text-secondary pb-3">Aluminio</th>
                    </tr>
                  </thead>
                  <tbody>
                    {comparativa.map((row, i) => (
                      <tr key={i} className={`border-b border-border ${i === comparativa.length - 1 ? "" : ""}`}>
                        <td className="font-body text-sm text-text-primary py-4 pr-4">{row.caracteristica}</td>
                        <td className="font-body text-sm text-primary py-4 pr-4">{row.pvc}</td>
                        <td className="font-body text-sm text-text-secondary py-4">{row.aluminio}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <p className="font-body text-xs text-text-secondary mt-4">
                  * Comparativa orientativa. Te asesoramos gratis según tu vivienda y necesidades.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section className="bg-white py-16 md:py-24">
          <div className="max-w-container mx-auto px-4 md:px-6">
            <div className="max-w-3xl mx-auto" itemScope itemType="https://schema.org/FAQPage">
              <h2 className="font-heading font-bold text-3xl md:text-4xl text-text-primary text-center mb-12">Preguntas frecuentes sobre persianas de PVC</h2>
              <div className="flex flex-col gap-4">
                {faqs.map((f, i) => (
                  <motion.div
                    key={i}
                    className="bg-surface-alt rounded-2xl p-6"
                    initial={{ opacity: 0, y: 10 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.4, delay: i * 0.08 }}
                    itemScope
                    itemProp="mainEntity"
                    itemType="https://schema.org/Question"
                  >
                    <h3 className="font-heading font-bold text-lg text-text-primary mb-2" itemProp="name">{f.q}</h3>
                    <div itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer">
                      <p className="font-body text-sm text-text-secondary leading-relaxed" itemProp="text">{f.a}</p>
                    </div>
                  </motion.div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* FORM */}
        <div id="presupuesto">
          <QuoteFormSection />
        </div>
      </main>
      <Footer />
      <WhatsAppFloating />
      <CookieBanner />
    </div>
  );
}